import { useCallback } from "react";
import { useNavigate } from "react-router";
import { PageMoreActions } from "@shared/components/PageMoreActions";
import { PageNavbar } from "@shared/components/PageNavbar";

type UsePageNavbarProps = {
  title: string;
  subtitle?: string;
  /** Only sub-pages reached by drilling into something (e.g. a specific
   * contact) should show a back arrow instead of the menu button. */
  showBackButton?: boolean;
  /** Where the back arrow always navigates to, regardless of browser
   * history. Omit to fall back to history-based back navigation. */
  backTo?: string;
  rightElement?: React.ReactNode;
};

export function usePageNavbar(props: UsePageNavbarProps) {
  const { title, subtitle, showBackButton = false, backTo, rightElement } =
    props;
  const navigate = useNavigate();

  const goBack = useCallback(() => {
    if (backTo) {
      navigate(backTo);
      return;
    }
    if (Number(window.history.state?.idx) > 0) {
      navigate(-1);
    } else {
      navigate("/");
    }
  }, [navigate, backTo]);

  return (
    <PageNavbar
      title={title}
      subtitle={subtitle}
      onBack={showBackButton ? goBack : undefined}
      rightElement={rightElement ?? <PageMoreActions />}
    />
  );
}
